export enum DialogEnum {
  Specimen = "specimen",
  FlatDiagnosis = "flat_diagnosis",
  InputDiagnosis = "input_diagnosis",
  ReadOnlyDiagnosis = "pending_diagnosis",
  WplDiagnosis = "wpl_diagnosis",
  AIOverlay = "aiOverlay",
  Hotkeys = "hotkeys",
  PhysicianPreferences = "preferences",
  StainOrdering = "stain_ordering",
}
